import Vue from 'vue'
import App from './App'
//import router from './router'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  //router,
  el: '#app',
  render: h => h(App),
})





// WEBPACK FOOTER //
// ./src/main.js